import CategoryView from '../category/CategoryView';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function Campus() {
  usePageMeta({
    title: '韩漫网校园漫画分类直达 - 韩漫漫画网',
    description: '韩漫网校园漫画分类：青春同窗、社团热血、成长故事一站直达。韩漫漫画网聚合校园题材热门作品，分类清晰，点开即看。',
    keywords: '韩漫漫画网,韩漫网校园漫画,校园韩漫,青春韩漫,韩漫题材分类',
    canonical: 'https://lovecomix.github.io/campus',
  });
  return <CategoryView type="campus" />;
}